import { EntityMetadata } from '@ngrx/data';
import { HttpResourceUrls } from '@ngrx/data/src/dataservices/http-url-generator';
import { Provider } from '../../../core/model/central/provider.model';

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const providerEntityMetadata: EntityMetadata<Provider> = {
    entityName: 'Provider',
    selectId: providerSelectId // .id is used if doing optimistic update
    // additionalCollectionState: {
    //     userId: 1 // extra properties
    // }
    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const providerHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : '/servlets/providers/entity/',
    collectionResourceUrl: '/servlets/providers/entities/'
};

// tslint:disable-next-line:only-arrow-functions typedef
export function providerSelectId<T extends { id: any }>(provider: Provider) {
    return  provider === undefined ? undefined : provider.id || provider.providerId;  // .id is used if doing optimistic update
}

